import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import '../src/assets/css/style.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import 'react-tabs/style/react-tabs.css';
import Loading from './pages/Loading';
import Blogs from './pages/Blogs';
import Blog from './pages/Blog';

// Pages
const Home = React.lazy(() => import('./pages/Home'));
const OrberaBalloon = React.lazy(() => import('./pages/OrberaBalloon'));
const ESG = React.lazy(() => import('./pages/ESG'));
const GastricRevisions = React.lazy(() => import('./pages/GastricRevisions'));
const WeightLoss = React.lazy(() => import('./pages/WeightLoss'));
const OurTeam = React.lazy(() => import('./pages/OurTeam'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));
const FAQs = React.lazy(() => import('./pages/FAQs'));
const LandingPage = React.lazy(() => import('./pages/LandingPage'));
const BMICalculator = React.lazy(() => import('./pages/BMICalculator'));
const FinancingAndInsurance = React.lazy(() => import('./pages/FinancingAndInsurance'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const ESGLandingPage = React.lazy(() => import('./pages/ESGLandingPage'));
const BookAnAppointment = React.lazy(() => import('./pages/BookAnAppointment'));
const Colonoscopy = React.lazy(() => import('./pages/digestive/Colonoscopy'));
const CapsoVisionEndoscopy = React.lazy(() => import('./pages/digestive/CapsoVisionEndoscopy'));
const ERCP = React.lazy(() => import('./pages/digestive/ERCP'));
const PEG = React.lazy(() => import('./pages/digestive/PEG'));
const RadioFrequencyAblation = React.lazy(() => import('./pages/digestive/RadioFrequencyAblation'));
const UpperEndoscopy = React.lazy(() => import('./pages/digestive/UpperEndoscopy'));
const GastricRevisionsLandingPage = React.lazy(() => import('./pages/GastricRevisionsLandingPage'));
const OrberaLandingPage = React.lazy(() => import('./pages/OrberaLandingPage'));
const Digestive = React.lazy(() => import('./pages/Digestive'));
const SuccessStories = React.lazy(() => import('./pages/SuccessStories'));
const Error = React.lazy(() => import('./pages/Error'));
const ThankYou = React.lazy(() => import('./pages/ThankYou'));
const Education = React.lazy(() => import('./pages/Education'));

const App = () => {
  return (
    <>
    
        <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="/our-team" element={<OurTeam/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/bmi-calculator" element={<BMICalculator/>} />
        <Route path="/education" element={<Education/>} />
        <Route path="/financing-and-insurance" element={<FinancingAndInsurance/>} />
        <Route path="/book-an-appointment" element={<BookAnAppointment/>} />
        <Route path="/blogs" element={<Blogs/>} />
          <Route path="/blog/:slug" element={<Blog/>} />        
          <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/landing-page" element={<LandingPage/>} />
        <Route path="/colonoscopy" element={<Colonoscopy/>} />
        <Route path="/capsovision-endoscopy" element={<CapsoVisionEndoscopy/>} />
        <Route path="/ercp" element={<ERCP/>} />
        <Route path="/peg" element={<PEG/>} />
        <Route path="/radio-frequency-ablation-therapy" element={<RadioFrequencyAblation/>} />
        <Route path="/upper-endoscopy" element={<UpperEndoscopy/>} />
        <Route path="*" element={<Error/>} />
        <Route path="/thank-you" element={<ThankYou/>} />
        <Route path="/esg" element={<ESGLandingPage/>} />
        <Route path="/faqs" element={<FAQs/>} />
        <Route path="/esg-long-island-ny" element={<ESG/>} />
        <Route path="/orbera-balloon-long-island-ny" element={<OrberaBalloon/>} />
        <Route path="/orbera-gastric-balloon" element={<OrberaLandingPage/>} />
        <Route path="/gastric-revisions-long-island-ny" element={<GastricRevisions/>} />
        <Route path="/gastric-revisions" element={<GastricRevisionsLandingPage/>} />
        <Route path="/non-surgical-weight-loss-long-island-ny" element={<WeightLoss/>} />
        <Route path="/digestive-procedures" element={<Digestive/>} />
        <Route path="/success-stories" element={<SuccessStories/>} />

        <Route path='/about-us/procedures' element={ <Navigate to="/non-surgical-weight-loss-long-island-ny" /> }/>
        <Route path='/2017/09/03/timing-of-melanoma-diagnosis-treatment-critical-to-survival' element={ <Navigate to="/contact-us" /> }/>
        <Route path='/bmi-calculators' element={ <Navigate to="/bmi-calculator" /> }/>
        <Route path='/shop/shop-single' element={ <Navigate to="/" /> }/>
        <Route path='/home' element={ <Navigate to="/" /> }/>
        <Route path='/photo-tour' element={ <Navigate to="/" /> }/>

        <Route path='/site' element={ <Navigate to="/" /> }/>
        <Route path='/appointments' element={ <Navigate to="/book-an-appointment" /> }/>
        <Route path='/shop' element={ <Navigate to="/" /> }/>
        <Route path='/services' element={ <Navigate to="/non-surgical-weight-loss-long-island-ny" /> }/>
        <Route path='/radiofrequency-ablation' element={ <Navigate to="/radio-frequency-ablation-therapy" /> }/>
        <Route path='/site/bmi-calculate' element={ <Navigate to="/bmi-calculator" /> }/>
        <Route path='/bmi-calculate' element={ <Navigate to="/bmi-calculator" /> }/>
        <Route path='/site/breath-tests' element={ <Navigate to="/digestive-procedures" /> }/>
        <Route path='/site/about-us' element={ <Navigate to="/about-us" /> }/>
        <Route path='/endoscopic-sleeve-gastroplasty' element={ <Navigate to="/esg-long-island-ny" /> }/>
        <Route path='/fast-track' element={ <Navigate to="/" /> }/>
        <Route path='/portfolio/breast-augmentation' element={ <Navigate to="/" /> }/>
        <Route path='/portfolio/liposculpture' element={ <Navigate to="/" /> }/>
        </Routes>
    </>
  );
}

export default App;
